module.exports = __webpack_public_path__ + "static/img/0022.eb820e52.png";